import { CustomButtonProps } from '@/components/Button/Button';

export const buttonLogInProps: CustomButtonProps = {
  variant: 'tertiary',
  w: 'full',
  h: '10',
};
